/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DipendenzaDTO
 */
export interface DipendenzaDTO {
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    codice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    citta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    provinciaCodice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    provinciaDescrizione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    nazioneCodice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaDTO
     */
    nazioneDescrizione?: string | null;
}

/**
 * Check if a given object implements the DipendenzaDTO interface.
 */
export function instanceOfDipendenzaDTO(value: object): value is DipendenzaDTO {
    return true;
}

export function DipendenzaDTOFromJSON(json: any): DipendenzaDTO {
    return DipendenzaDTOFromJSONTyped(json, false);
}

export function DipendenzaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DipendenzaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'codice': json['codice'] == null ? undefined : json['codice'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'citta': json['citta'] == null ? undefined : json['citta'],
        'provinciaCodice': json['provinciaCodice'] == null ? undefined : json['provinciaCodice'],
        'provinciaDescrizione': json['provinciaDescrizione'] == null ? undefined : json['provinciaDescrizione'],
        'nazioneCodice': json['nazioneCodice'] == null ? undefined : json['nazioneCodice'],
        'nazioneDescrizione': json['nazioneDescrizione'] == null ? undefined : json['nazioneDescrizione'],
    };
}

  export function DipendenzaDTOToJSON(json: any): DipendenzaDTO {
      return DipendenzaDTOToJSONTyped(json, false);
  }

  export function DipendenzaDTOToJSONTyped(value?: DipendenzaDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'codice': value['codice'],
        'nome': value['nome'],
        'indirizzo': value['indirizzo'],
        'cap': value['cap'],
        'citta': value['citta'],
        'provinciaCodice': value['provinciaCodice'],
        'provinciaDescrizione': value['provinciaDescrizione'],
        'nazioneCodice': value['nazioneCodice'],
        'nazioneDescrizione': value['nazioneDescrizione'],
    };
}

